/*
*
* Lightbox for the single post video (self-hosted mp4).
*
*/

export const postVideoLightbox = () => {
    const triggers = document.querySelectorAll('.bn-single-post-video__play, .bn-img__play');
    if (!triggers.length) return;

    let overlay = null;

    const close = () => {
        if (!overlay) return;
        const video = overlay.querySelector('video');
        if (video) video.pause();
        overlay.classList.remove('--active');
        overlay.innerHTML = '';
        document.body.classList.remove('bn-video-lightbox-open');
    };

    const open = ({ src, type, embed, poster }) => {
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.classList.add('bn-video-lightbox');
            document.body.append(overlay);

            overlay.addEventListener('click', (e) => {
                if (e.target === overlay) close();
            });
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && overlay.classList.contains('--active')) close();
            });
        }

        const media = embed
            ? `<div class="bn-video-lightbox__frame">
                    <iframe src="${embed}${embed.includes('?') ? '&' : '?'}autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                </div>`
            : `<video controls autoplay playsinline${poster ? ` poster="${poster}"` : ''}>
                    <source src="${src}" type="${type}">
                </video>`;

        overlay.innerHTML = `
            <div class="bn-video-lightbox__inner">
                <button type="button" class="bn-video-lightbox__close" aria-label="Zamknij">&times;</button>
                ${media}
            </div>`;

        overlay.querySelector('.bn-video-lightbox__close').addEventListener('click', close);
        overlay.classList.add('--active');
        document.body.classList.add('bn-video-lightbox-open');
    };

    triggers.forEach((button) => {
        button.addEventListener('click', () => {
            open({
                src: button.dataset.videoSrc || '',
                type: button.dataset.videoType || 'video/mp4',
                embed: button.dataset.videoEmbed || '',
                poster: button.dataset.videoPoster || ''
            });
        });
    });
};
